import { crystalColor } from "../lib/crystalColors";

export default function BraceletVisual({ layout, compact = false }) {
  if (!layout || layout.length === 0) return null;
  const radius = compact ? 95 : 135;
  const center = radius + 30;
  const n = layout.length;
  const size = (center * 2);
  return (
    <div className="flex flex-col items-center" data-testid="bracelet-visual">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="max-w-full h-auto">
        <defs>
          <radialGradient id="goldThread" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#f4dfa3" />
            <stop offset="100%" stopColor="#d4a855" />
          </radialGradient>
        </defs>
        <circle cx={center} cy={center} r={radius} fill="none" stroke="#e8ddc0" strokeWidth="1" strokeDasharray="3 3" />
        {layout.map((b, i) => {
          const angle = (i / n) * Math.PI * 2 - Math.PI / 2;
          const x = center + Math.cos(angle) * radius;
          const y = center + Math.sin(angle) * radius;
          const r = b.isPancha ? (compact ? 13 : 18) : (compact ? 9 : 12);
          const color = crystalColor(b.crystal);
          return (
            <g key={i}>
              <circle cx={x} cy={y} r={r + 1.5} fill="none" stroke={b.isPancha ? "#D4A855" : "transparent"} strokeWidth="1.2" />
              <circle cx={x} cy={y} r={r} fill={color} stroke="rgba(44,10,94,0.2)" strokeWidth="0.6">
                <title>{b.crystal}{b.isPancha ? " (Pancha " + b.element + ")" : ""}</title>
              </circle>
              {/* Highlight */}
              <circle cx={x - r / 3} cy={y - r / 3} r={r / 3} fill="rgba(255,255,255,0.5)" />
            </g>
          );
        })}
      </svg>
      {!compact && (
        <div className="mt-4 flex items-center gap-5 text-xs text-[#6B5E7E]">
          <span className="inline-flex items-center gap-2"><span className="inline-block w-3 h-3 rounded-full border border-[#D4A855]" />Pancha 8mm</span>
          <span className="inline-flex items-center gap-2"><span className="inline-block w-2.5 h-2.5 rounded-full bg-[#c8c8c8]" />Prescription 8mm</span>
        </div>
      )}
    </div>
  );
}
